export default __webpack_public_path__ + "static/media/background.4b17d687.jpg";